<template>
  <div class="page-content">
    <div class="card">
      <LoadingIndicator size="large" :icon="content.image" class="card-image" />
      <h3>{{ content.title }}</h3>
    </div>
  </div>
</template>
<script>
import LoadingIndicator from "@/components/LoadingIndicator.vue";
export default {
  props: {
    content: {
      type: Object,
      required: false,
      default: () => ({
        title: String,
        description: String,
        image: String,
      }),
    },
    componentType: {
      type: String,
      required: false,
    },
    action: {
      type: Function,
      default: () => null,
    },
  },
  components: { LoadingIndicator },
  mounted() {
    setTimeout(() => {
      this.action();
    }, 2000);
  },
};
</script>
